const styles = {
  global: {
    body: {
      bg: 'primary.900',
    },
  },
};

export {styles};
